import React, { FC } from 'react';
import { format } from 'date-fns';
import * as translations from './strings';
import { getLangKey } from '../../../../models/Language';
import DetailsLabel from '../DetailsLabel';
import styles from './styles.module.css';

const strings = translations[getLangKey()];

type Props = {
  createdAt: string;
  email?: string;
  display: string;
  asFields?: boolean;
};

const ReportedBy: FC<Props> = ({ createdAt, email, display, asFields }) => {
  if (asFields) {
    const reportedAt = format(
      new Date(createdAt),
      "MMM d, yyyy 'at' h:mmaaa"
    );

    return (
      <>
        <div className={styles.fieldRow}>
          <DetailsLabel label={strings.reportedBy} />
          <span className={styles.fieldValue} title={display}>
            {display}
          </span>
        </div>
        <div className={styles.fieldRow}>
          <DetailsLabel label={strings.dateReported} />
          <span className={styles.fieldValue} title={reportedAt}>
            {reportedAt}
          </span>
        </div>
      </>
    );
  }

  return (
    <div className={styles.createdContainer}>
      <span className={styles.created}>
        <span
          className={styles.createdTime}
          title={new Date(createdAt).toString()}
        >
          {`${strings.reported} ${format(
            new Date(createdAt),
            "MMM d, yyyy 'at' h:mmaaa"
          )}, ${strings.by} `}
          {email ? (
            <a
              title={display}
              href={`mailto:${email}`}
              className={styles.creator}
            >
              {display}
            </a>
          ) : (
            <span className={styles.creator} title={display}>
              {display}
            </span>
          )}
        </span>
      </span>
    </div>
  );
};

export default ReportedBy;
